export default __webpack_public_path__ + "static/media/faibrik_white.b7ef0469.png";